import ApplyCTA from "@/components/shared/ApplyCTA";

export default function FinalCTA() {
  return (
    <section className="access-section relative overflow-hidden">
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[60vh] pointer-events-none -z-10"
           style={{ background: "radial-gradient(ellipse at center, rgba(201,169,110,0.15), transparent 60%)" }} />
      <div className="access-container max-w-3xl text-center">
        <span className="mono-label mono-label-gold">THE CALL</span>
        <h2 className="h-section mt-5 text-balance">
          You can keep watching free content. Or you can <span style={{ color: "var(--gold-strong)" }}>be in the room.</span>
        </h2>
        <p className="body-lg mt-7 text-dim">12 spots open this month. Application takes 2 minutes.</p>
        <div className="mt-10 flex flex-col items-center gap-4">
          <ApplyCTA className="!min-h-[60px] !px-12 !text-sm" />
          <p className="mono-label text-mute">AFTER THE APPLICATION, YOU'LL BOOK DIRECTLY INTO THE CALENDAR</p>
        </div>
      </div>
    </section>
  );
}
